import React from "react";
import styled, { keyframes } from "styled-components";

const bouncingAnimation = keyframes`
    to {
      transform: translateY(-10px);
    }
`;

const BouncingLoader = styled.div`
    display: flex;
    justify-content: center;
    & > div {
        width: 12px;
        height: 12px;
        margin: 0;
        border-radius: 50%;
        margin-right: 6px;
        background-color: #a3a1a1;
        opacity: 1;
        animation: ${bouncingAnimation} 0.6s infinite alternate;
    }

    & > div:nth-child(2) {
        animation-delay: 0.2s;
    }

    & > div:nth-child(3) {
        animation-delay: 0.4s;
    }
`;

const BouncingDots = (props) => {
  return (
      <BouncingLoader>
        <div></div>
        <div></div>
        <div></div>
      </BouncingLoader>
  );
};

export default BouncingDots;